var map = {
	"./ion-action-sheet-ios.entry.js": [
		837,
		11
	],
	"./ion-action-sheet-md.entry.js": [
		838,
		12
	],
	"./ion-alert-ios.entry.js": [
		839,
		13
	],
	"./ion-alert-md.entry.js": [
		840,
		14
	],
	"./ion-app_8-ios.entry.js": [
		841,
		15
	],
	"./ion-app_8-md.entry.js": [
		842,
		16
	],
	"./ion-avatar_3-ios.entry.js": [
		843,
		33
	],
	"./ion-avatar_3-md.entry.js": [
		844,
		34
	],
	"./ion-back-button-ios.entry.js": [
		845,
		35
	],
	"./ion-back-button-md.entry.js": [
		846,
		36
	],
	"./ion-backdrop-ios.entry.js": [
		847,
		77
	],
	"./ion-backdrop-md.entry.js": [
		848,
		78
	],
	"./ion-button_2-ios.entry.js": [
		849,
		37
	],
	"./ion-button_2-md.entry.js": [
		850,
		38
	],
	"./ion-card_5-ios.entry.js": [
		851,
		39
	],
	"./ion-card_5-md.entry.js": [
		852,
		40
	],
	"./ion-checkbox-ios.entry.js": [
		853,
		41
	],
	"./ion-checkbox-md.entry.js": [
		854,
		42
	],
	"./ion-chip-ios.entry.js": [
		855,
		43
	],
	"./ion-chip-md.entry.js": [
		856,
		44
	],
	"./ion-col_3.entry.js": [
		857,
		79
	],
	"./ion-datetime_3-ios.entry.js": [
		858,
		21
	],
	"./ion-datetime_3-md.entry.js": [
		859,
		22
	],
	"./ion-fab_3-ios.entry.js": [
		860,
		45
	],
	"./ion-fab_3-md.entry.js": [
		861,
		46
	],
	"./ion-img.entry.js": [
		862,
		80
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		863,
		81
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		864,
		82
	],
	"./ion-input-ios.entry.js": [
		865,
		47
	],
	"./ion-input-md.entry.js": [
		866,
		48
	],
	"./ion-item-option_3-ios.entry.js": [
		867,
		49
	],
	"./ion-item-option_3-md.entry.js": [
		868,
		50
	],
	"./ion-item_8-ios.entry.js": [
		869,
		51
	],
	"./ion-item_8-md.entry.js": [
		870,
		52
	],
	"./ion-loading-ios.entry.js": [
		871,
		53
	],
	"./ion-loading-md.entry.js": [
		872,
		54
	],
	"./ion-menu_3-ios.entry.js": [
		873,
		55
	],
	"./ion-menu_3-md.entry.js": [
		874,
		56
	],
	"./ion-modal-ios.entry.js": [
		875,
		17
	],
	"./ion-modal-md.entry.js": [
		876,
		18
	],
	"./ion-nav_2.entry.js": [
		877,
		29
	],
	"./ion-popover-ios.entry.js": [
		878,
		19
	],
	"./ion-popover-md.entry.js": [
		879,
		20
	],
	"./ion-progress-bar-ios.entry.js": [
		880,
		57
	],
	"./ion-progress-bar-md.entry.js": [
		881,
		58
	],
	"./ion-radio_2-ios.entry.js": [
		882,
		59
	],
	"./ion-radio_2-md.entry.js": [
		883,
		60
	],
	"./ion-range-ios.entry.js": [
		884,
		61
	],
	"./ion-range-md.entry.js": [
		885,
		62
	],
	"./ion-refresher_2-ios.entry.js": [
		886,
		23
	],
	"./ion-refresher_2-md.entry.js": [
		887,
		24
	],
	"./ion-reorder_2-ios.entry.js": [
		888,
		31
	],
	"./ion-reorder_2-md.entry.js": [
		889,
		32
	],
	"./ion-ripple-effect.entry.js": [
		890,
		83
	],
	"./ion-route_4.entry.js": [
		891,
		63
	],
	"./ion-searchbar-ios.entry.js": [
		892,
		64
	],
	"./ion-searchbar-md.entry.js": [
		893,
		65
	],
	"./ion-segment_2-ios.entry.js": [
		894,
		66
	],
	"./ion-segment_2-md.entry.js": [
		895,
		67
	],
	"./ion-select_3-ios.entry.js": [
		896,
		68
	],
	"./ion-select_3-md.entry.js": [
		897,
		69
	],
	"./ion-slide_2-ios.entry.js": [
		898,
		84
	],
	"./ion-slide_2-md.entry.js": [
		899,
		85
	],
	"./ion-spinner.entry.js": [
		900,
		27
	],
	"./ion-split-pane-ios.entry.js": [
		901,
		86
	],
	"./ion-split-pane-md.entry.js": [
		902,
		87
	],
	"./ion-tab-bar_2-ios.entry.js": [
		903,
		70
	],
	"./ion-tab-bar_2-md.entry.js": [
		904,
		71
	],
	"./ion-tab_2.entry.js": [
		905,
		30
	],
	"./ion-text.entry.js": [
		906,
		72
	],
	"./ion-textarea-ios.entry.js": [
		907,
		73
	],
	"./ion-textarea-md.entry.js": [
		908,
		74
	],
	"./ion-toast-ios.entry.js": [
		909,
		75
	],
	"./ion-toast-md.entry.js": [
		910,
		76
	],
	"./ion-toggle-ios.entry.js": [
		911,
		25
	],
	"./ion-toggle-md.entry.js": [
		912,
		26
	],
	"./ion-virtual-scroll.entry.js": [
		913,
		88
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 804;
module.exports = webpackAsyncContext;